import {
	Tooltip,
	Box,
} from '@material-ui/core';
// import { DataGrid } from "@material-ui/data-grid";
import * as dayjs from 'dayjs';
import React from 'react';
import { useValues } from 'kea';
import MUIDataTable from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { rkeylogic } from 'src/store/report';
import KeyDataDialog from './AddDataDialogs/KeyDialog';
import PrintToolbarPlugin from '../../../utils/PDFDialog/PDFToolbarPlugin';
import CSVToolbarPlugin from '../../../utils/CSVDialog/CSVToolbarPlugin';


const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

const columns = [
	{
		name: 'timestamp',
		label: 'Time',
		align: 'left',
		width: 150,
		options: {
			filter: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'key',
		label: 'Key',
		align: 'left',
		width: 130,
		options: {
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'address',
		label: 'Address',
		align: 'left',
		width: 240,
		options: {
			display: false,
			customBodyRender: (param) => withTooltip(param)
		}
	},
	{
		name: 'fulladdress',
		label: 'Location',
		align: 'left',
		noprint: true,
		width: 240,
		options: {
			customBodyRender: (param) => {
				return (<>
					<a target="_blank" rel="noopener"
						href={`https://www.google.com/maps/place/${param?.latitude},${param?.longitude}`}>
						{withTooltip(param?.address)}
					</a>
				</>)
			}
		}
	}
];

const Key = () => {
	// const classes = useStyles();
	const { trips, vehicle } = useValues(rkeylogic);
	const [data, setData] = React.useState([]);

	const getMuiTheme = () => createTheme({
		overrides: {
			MUIDataTableBodyCell: {
				root: {
					padding: "4px"
				}
			}
		}
	})


	React.useEffect(() => {
		// console.log('running')
		if (trips.length > 0) {
			let newRows = trips.map((row, count) => {
				return {
					id: count,
					timestamp: `${dayjs(row.position_timestamp).format('h:mm a DD MMM YY')}`,
					key: row.ibutton,
					fulladdress: row,
					address: row.address,
				}
			});
			setData(newRows);
		} else {
			setData([])
		}
	}, [trips]);

	const options = {
		textLabels: {
			body: {
				noMatch: "No data. Please create a report first using the + button located in the top right corner of this table."
			}
		},
		selectableRows: 'none',
		print: false,
		download: false,
		tableBodyHeight: '100%',
		rowsPerPage: 15,
		customToolbar: (data) =>
			<span >
				{/* <br /> */}
				<PrintToolbarPlugin title='Key Report' rows={data} columns={columns} filename={'Key_history'} />
				<CSVToolbarPlugin rows={data} columns={columns} filename={'Key_history'} />
				<KeyDataDialog />
			</span>
	};

	return (
		<div>
			<Box mt={1}>

				<MuiThemeProvider theme={getMuiTheme()}>
					<MUIDataTable
						title={"Key History Report" + (vehicle ? `: ${vehicle.name} - ${vehicle.registration_number}` : '')}
						data={data}
						columns={columns}
						options={options}
					/>
				</MuiThemeProvider>
			</Box>
		</div>
	);
};


export default Key;
